var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferralsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "User-Multiple-Group--Streamline-Core.svg",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "User Multiple Group Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-multiple-group--close-geometric-human-multiple-person-up-user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5 6.5c1.38071 0 2.5 -1.11929 2.5 -2.5S6.38071 1.5 5 1.5 2.5 2.61929 2.5 4 3.61929 6.5 5 6.5Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0.5 13.5h9v-0.5421c-0.00796 -0.7622 -0.20898 -1.51 -0.58427 -2.1734 -0.3753 -0.6635 -0.91263 -1.221 -1.5618 -1.62049 -0.64918 -0.3995 -1.38902 -0.62793 -2.15041 -0.66398C5.13564 8.49682 5.06778 8.49514 5 8.495c-0.06778 0.00014 -0.13564 0.00182 -0.20352 0.00503 -0.76139 0.03605 -1.50123 0.26448 -2.15041 0.66398 -0.64917 0.39949 -1.1865 0.95699 -1.5618 1.62049C0.708977 11.4479 0.507961 12.1957 0.5 12.9579V13.5Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 6.5c1.3807 0 2.5 -1.11929 2.5 -2.5S10.3807 1.5 9 1.5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.5 13.5001h2v-0.5422c-0.008 -0.7622 -0.209 -1.51 -0.5843 -2.1734 -0.3753 -0.6635 -0.9126 -1.22098 -1.5618 -1.62047 -0.4196 -0.25825 -0.8772 -0.44501 -1.3539 -0.55453",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralsIcon);
export default __webpack_public_path__ + "static/media/referrals-icon.68d438d8e214bc0fc67e9d6a22f5d37f.svg";
export { ForwardRef as ReactComponent };